import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";

export const RootRedirect = observer(function RootRedirect() {
  useEffect(() => {
    userStore.load();
  }, []);

  if (userStore.authed === null) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return <Navigate to={userStore.authed ? "/profile" : "/login/1"} replace />;
});
